<template>
  <div v-if="progress" class="leftbox" style="overflow-y: hidden !important; margin-top: 100px !important;">
    <v-layout align-center justify-center>
      <v-progress-circular :size="100" :width="8" indeterminate color="blue"></v-progress-circular>
    </v-layout>
  </div>
  <div style="overflow-y: hidden !important;" class="leftbox" v-else>
    <v-toolbar style="background-color: white !important;">
      <!-- <v-btn icon @click="toPage('/account/')">
        <v-icon>chevron_left</v-icon>
      </v-btn> -->
      <h2>รายการอีเวนท์</h2>
    </v-toolbar>
    <v-flex xs12 xl12 md12 sm12 lg12 style="margin-bottom: 20vh;">
      <div>
        <v-data-table
          :headers="headers"
          :items="listEvent"
          :loading="loading"
          hide-actions
          class=""
          style="cursor: pointer; height: calc(100vh - 220px); overflow-y: scroll;"
        >
        <template slot="headers" slot-scope="props">
          <tr style="text-align: center;">
            <th
              v-for="header in props.headers"
              class="headertable"
              :key="header.text"
            >
              {{ header.text }}
              <v-icon small v-if="header.value && stateDate === 'new'" @click="changestateDate('old')">arrow_upward</v-icon>
              <v-icon small v-else-if="header.value && stateDate === 'old'"  @click="changestateDate('new')">arrow_downward</v-icon>
            </th>
          </tr>
        </template>
          <template v-slot:items="props">
            <td @click="routeEvent(props.item)">{{ props.item.event_id }}</td>
            <td @click="routeEvent(props.item)">{{ props.item.event_name }}</td>
            <td @click="routeEvent(props.item)">{{ props.item.name }}</td>
            <td @click="routeEvent(props.item)">{{ momentday(props.item.date) }}</td>
          </template>
          <!-- <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} / of {{ props.itemsLength }}
          </template> -->
        </v-data-table>
        <!-- <div class="text-xs-center pt-2">
          <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </div> -->
      </div>
    </v-flex>
  </div>
</template>
<script>
import { Momenttime, Decode } from '@/services'
var _ = require('lodash')
export default {
  components: {
  },
  data: () => ({
    listEvent: [],
    fileName: '',
    isLoading: false,
    fileData: '',
    loading: false,
    message: '',
    tabs: 'tab-1',
    tokenservice: '',
    listfriend: [],
    progress: false,
    search: '',
    totalDesserts: 0,
    desserts: [],
    pagination: {},
    headers: [
      { text: 'รหัส event', value: false },
      { text: 'ชื่อ event', value: false },
      { text: 'หมวดหมู่', value: false },
      { text: 'วันที่จัด event', value: true }
    ],
    stateDate: 'new',
    tokenuser: ''
  }),
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
      this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  watch: {
    '$route.params.id' () {
      this.getlistfrienbot()
      // this.getlistevent()
    }
  },
  mounted () {
  },
  created () {
    // this.tokenservice = 'Bearer ' + localStorage.getItem('tokenservice')
    this.tokenservice = 'Bearer ' + Decode.decodeToken(localStorage.getItem('tokenservice'))
    this.tokenuser = Decode.decodeToken(localStorage.getItem('tokenuser'))
    this.getlistfrienbot()
    // this.getlistevent()
  },
  methods: {
    changestateDate (state) {
      this.listEvent = _.sortBy(this.listEvent, function (dateObj) {
        return new Date(dateObj.date)
      })
      if (state === 'old') {
        // console.log('old')
        this.stateDate = 'old'
      } else {
        // console.log('new')
        this.listEvent.reverse()
        this.stateDate = 'new'
      }
    },
    routeEvent (data) {
      // console.log(data)
      // console.log(this.$route.params.id)
      localStorage.setItem('category', data.category)
      localStorage.setItem('eventid', data.event_id)
      localStorage.setItem('eventname', data.event_name)
      var botid = this.$route.params.id
      this.$router.push('/event/' + botid + '/' + data.name + '/' + data.event_id)
    },
    momentday (data) {
      return Momenttime.momentdatethaievent(data)
    },
    getlistevent () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_DEVELOP + '/get/list_event', { tokenbot: this.$route.params.id, tokenuser: this.tokenuser }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.listEvent = response.data.data
          this.listEvent = _.sortBy(this.listEvent, function (dateObj) {
            return new Date(dateObj.date)
          })
          this.listEvent.reverse()
          // console.log(response.data.data)
        } else {
          this.progress = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    reset () {
      this.fileName = ''
      this.fileData = ''
    },
    setFileName () {
      this.fileName = this.$refs.fileTest.files[0].name
      var typeFile = this.$refs.fileTest.files[0].type
      this.fileData = this.$refs.fileTest.files[0]
      // console.log(this.$refs.fileTest.files[0].size / 1024 / 1024)
      if (this.$refs.fileTest.files[0].size / 1024 / 1024 > 25) {
        this.$swal({ title: 'ไฟล์ของท่านมีขนาดเกิน 25 MB', type: 'warning' })
        this.reset()
      }
      if (typeFile.search('image') !== -1) {
        var fr = new FileReader()
        fr.onload = function () {
          document.getElementById('img_file').src = fr.result
        }
        fr.readAsDataURL(this.fileData)
      }
    },
    extension (files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else {
        return 'fas fa-file-alt'
      }
    // return extension[extension.length-1]
    },
    sendbroadcast () {
      this.loading = true
      if (this.listfriend.length !== 0) {
        this.$swal({
          title: 'ยืนยันการส่งข้อความ',
          text: 'คุณต้องการส่งข้อความไปหาเพื่อนทุกคนใช่หรือไม่',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            this.axios.post(process.env.VUE_APP_API_IMAGE + '/broadcast_message', { tokenuser: this.$route.params.id, message: this.message }).then((response) => {
              if (response.data.status === 'success') {
                this.$swal({
                  title: 'ส่งข้อความสำเร็จ',
                  type: 'success',
                  showConfirmButton: true,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'ตกลง'
                })
                this.loading = false
                this.message = ''
              } else {
                this.progress = true
              }
            })
          } else {
            this.loading = false
          }
        })
      } else {
        this.$swal({
          text: 'ไม่สามารถส่งข้อความ เนื่องจากคุณยังไม่มีเพื่อน',
          type: 'warning',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ตกลง'
        })
        this.loading = false
        this.message = ''
      }
    },
    broadcast () {
      if (!this.fileData) {
        this.$swal({ title: 'กรุณาเลือกไฟล์', type: 'warning' })
        return
      }
      if (this.listfriend.length !== 0) {
        this.$swal({
          title: 'ยืนยันการส่งข้อความ',
          text: 'คุณต้องการส่งข้อความไปหาเพื่อนทุกคนใช่หรือไม่',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            this.loading = true
            var data = new FormData()
            data.append('tokenuser', this.$route.params.id)
            data.append('file', this.$refs.fileTest.files[0])

            this.axios.post(process.env.VUE_APP_API_IMAGE + '/broadcast_file', data).then((response) => {
              this.loading = false
              if (response.data.status === 'success') {
                this.reset()
                this.$swal({ title: 'ส่งข้อความสำเร็จ', type: 'success' })
              }
            })
          }
        })
      } else {
        this.$swal({
          text: 'ไม่สามารถส่งข้อความ เนื่องจากคุณยังไม่มีเพื่อน',
          type: 'warning',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ตกลง'
        })
        this.loading = false
        this.reset()
      }
    },
    clear () {
      this.message = ''
    },
    getlistfrienbot () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistfriend', { tokenuser: this.$route.params.id }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.listfriend = response.data.listfriend
          this.progress = false
        } else {
          this.progress = true
        }
      })
    },
    toPage (data) {
      // console.log(data)
      this.$router.push(data + this.$route.params.id)
    }
  }
}
</script>
<style type="text/css" scoped>
.text2 {
  white-space: nowrap;
  width: 155px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 300px !important;
  height: 185px !important;
  position: relative;
  background: white;
}
.containers {
  width: 576px; margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

[class*='close-'] {
  color: #777;
  font: 27px/100% arial, sans-serif;
  position: absolute;
  right: 15px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
.buttonsubmit {
  background-color: #607d8b !important;
  border-radius: 8px !important;
  color: white !important;
  text-transform: none !important;
}
.buttoncancel {
  border-radius: 8px !important;
  color: #4c4c4c !important;
  text-transform: none !important;
  border-color: #8080807d !important;
  border-style: solid !important;
  border-width: thin !important;
}
.fontchat {
  color: gray;
  font-size: 12px;
}
.leftbox {
  height: calc(100vh - 64px);
  background-color: #fff !important;
  overflow: scroll;
}
>>>.v-input__slot {
  width: 100%;
  border-radius: 20px;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  height: 100px !important;
  border-radius: 20px !important;
  width: 100% !important;
  border-style: solid !important;
  border-color: #c1c1c1 !important;
  box-shadow: none !important;
  border-width: thin !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 2px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-table__overflow {
  width: 100% !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
}
</style>
